import { Injectable } from '@angular/core';
import { OutputWebSocketMessage } from 'src/app/models/ws/output-websocket-message';
import { environment } from 'src/environments/environment';
import { TChatStateService } from '../state/tchat-state.service';

@Injectable({
    providedIn: 'root',
})
export class WebSocketTchatService {
    //baseUrl = environment.wsUrl;
    baseUrl;

    private socket: WebSocket;

    /**
     * Constructeur
     */
    constructor(private tchatService: TChatStateService) {
        if (environment.production) {
            var loc = window.location;
            if (loc.protocol === 'https:') {
                this.baseUrl = 'wss:';
            } else {
                this.baseUrl = 'ws:';
            }
            this.baseUrl += '//' + loc.host;
        } else {
            this.baseUrl = environment.wsUrl;
        }
    }

    /**
     * Ouverture d'une webSocket
     * @param login : Login de l'utilisateur
     */
    public startSocket(organizationId: string, login: string) {
        // this.socket = new WebSocket(`${this.baseUrl}/tchat/ws?user=${login}&organizationId=${organizationId}`);
        // this.socket.addEventListener('open', (ev) => {});
        // this.socket.addEventListener('message', (ev) => {
        // 	var messageWrapper: WebSocketMessage = WebSocketMessage.fromJson(JSON.parse(ev.data));
        // 	switch (messageWrapper.messageType) {
        // 		case WebSocketMessageType.ConnectedUser:
        // 			let connectedUserNotification: UserNotification = UserNotification.fromJson(JSON.parse(messageWrapper.payload));
        // 			this.tchatService.setUserOnline(connectedUserNotification.login, true);
        // 			break;
        // 		case WebSocketMessageType.DisconnectedUser:
        // 			let disconnectedUserNotification: UserNotification = UserNotification.fromJson(JSON.parse(messageWrapper.payload));
        // 			this.tchatService.setUserOnline(disconnectedUserNotification.login, false);
        // 			break;
        // 		case WebSocketMessageType.CreateRoom:
        // 			let createRoomNotification: TchatNotification = TchatNotification.fromJson(JSON.parse(messageWrapper.payload));
        // 			this.tchatService.addRoom(createRoomNotification.room);
        // 			break;
        // 		case WebSocketMessageType.NewTchatMessage:
        // 			let newTchatMessageNotification: TchatNotification = TchatNotification.fromJson(JSON.parse(messageWrapper.payload));
        // 			this.tchatService.setRoom(newTchatMessageNotification.room);
        // 			break;
        // 		case WebSocketMessageType.KillRoom:
        // 			let killRoomNotification: TchatNotification = TchatNotification.fromJson(JSON.parse(messageWrapper.payload));
        // 			this.tchatService.removeRoom(killRoomNotification.room);
        // 			break;
        // 		default:
        // 			break;
        // 	}
        // });
    }

    /**
     * Arret de la webSocket
     * @param login : Login de l'utilisateur
     */
    public stopSocket(login: string) {
        // this.sendMessageRequest(new OutputWebSocketMessage('disconnect', null));
    }

    /**
     * Envoi d'une requête par la webSocket;
     * @param req : Requête a envoyé
     */
    public sendMessageRequest(req: OutputWebSocketMessage) {
        // var requestAsJson = JSON.stringify(req);
        // this.socket.send(requestAsJson);
    }
}
